import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-broad-collapse-icon-white",
  "use": "icon-broad-collapse-icon-white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-broad-collapse-icon-white\">\n  <rect x=\"2.5\" y=\"3.5\" width=\"19\" height=\"17\" rx=\"3.5\" fill=\"#409eff\" />\n  <circle cx=\"6.2\" cy=\"7.9\" r=\"0.9\" fill=\"#ffffff\" />\n  <circle cx=\"6.2\" cy=\"12\" r=\"0.9\" fill=\"#ffffff\" />\n  <circle cx=\"6.2\" cy=\"16.1\" r=\"0.9\" fill=\"#ffffff\" />\n  <rect x=\"8.5\" y=\"7\" width=\"10\" height=\"1.8\" rx=\"0.9\" fill=\"#ffffff\" />\n  <rect x=\"8.5\" y=\"11.1\" width=\"10\" height=\"1.8\" rx=\"0.9\" fill=\"#ffffff\" />\n  <rect x=\"8.5\" y=\"15.2\" width=\"10\" height=\"1.8\" rx=\"0.9\" fill=\"#ffffff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/broad/broad-collapse-icon-white.svg
// module id = t+2v
// module chunks = 24